import Navbar from 'components/navbar';
import { PrinterIcon } from 'lucide-react';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import { commaSeparatedNumbers } from 'utils/commaSeparatedNumbers';
import classes from './jobTagScreen.module.scss';
import { useJobTagsScreen } from './useJobTagScreen';

const JobTagScreen = () => {
  const {
    isAllJobsLoading,
    allJobs,
    selectedJobId,
    isJobDetailsLoading,
    jobDetails,
    contentRef,
    handleDropdownOptionChange,
    getDate,
    getTime,
    getRoomcolor,
    handlePrint,
  } = useJobTagsScreen();

  return (
    <div className={classes.jobTagComponent}>
      <Navbar heading="Job Tags" />
      <div className={classes.contentContainer}>
        <div className={classes.dropdownContainer}>
          <p>Job Id:</p>
          <Dropdown
            filter
            loading={isAllJobsLoading}
            className={classes.dropdown}
            value={selectedJobId}
            options={allJobs}
            onChange={e => handleDropdownOptionChange(e.value)}
            defaultValue={allJobs[0]}
            optionLabel="jobs"
          />
        </div>
        {isJobDetailsLoading ? (
          <Skeleton height="100rem" />
        ) : (
          <div id="content" className={classes.content} ref={contentRef}>
            <div id="headerContainer" className={classes.headerContainer}>
              <div>
                <p>
                  <span style={{ color: '#4D2E6D', fontWeight: '600' }}>Date: </span>
                  {getDate()}
                  <span className="timestamp" style={{ display: 'none' }}>
                    {' '}
                    {getTime()}
                  </span>
                </p>
              </div>
              <div>
                <Button
                  id="print-btn"
                  icon={<PrinterIcon color="#4D2E6D" />}
                  rounded
                  style={{ backgroundColor: '#D6B1FD', border: 'none' }}
                  onClick={handlePrint}
                />
              </div>
            </div>
            <div id="jobDetailContainer" className={classes.jobDetailContainer}>
              <div id="jobIdContainer" className={classes.jobIdContainer}>
                <p
                  style={{
                    textAlign: 'center',
                    fontSize: '90px',
                    fontWeight: '500',
                    margin: '0',
                    padding: '0'
                  }}
                >
                  {jobDetails?.job_id}
                </p>
                <p
                  style={{
                    textAlign: 'center',
                    fontSize: '50px',
                    fontWeight: '500',
                    margin: '0',
                    padding: '0',
                    color: `${getRoomcolor(jobDetails?.Room_id__room_long || '')}`
                  }}
                >
                  {jobDetails?.Room_id__room_long}
                </p>
              </div>
              <div className={classes.jobDetails} id="job-details">
                <div
                  id="jobDetailsRow"
                  className={classes.jobDetailsRow}
                  style={{ backgroundColor: '#F1F2F699', borderTop: '1px solid #D6B1FD' }}
                >
                  <span id="jobDetailKey" className={classes.jobDetailKey}>
                    NDC :{' '}
                  </span>
                  <span id="jobDetailValue" className={classes.jobDetailValue}>
                    &nbsp;{jobDetails?.DrugReferenceFgNDC}
                  </span>
                </div>
                <div
                  id="jobDetailsRow"
                  className={classes.jobDetailsRow}
                  style={{ borderTop: '1px solid #D6B1FD' }}
                >
                  <span id="jobDetailKey" className={classes.jobDetailKey}>
                    NAME :
                  </span>
                  <span id="jobDetailValue" className={classes.jobDetailValue}>
                    &nbsp;{jobDetails?.drug_description}
                  </span>
                </div>
                <div
                  id="jobDetailsRow"
                  className={classes.jobDetailsRow}
                  style={{ backgroundColor: '#F1F2F699', borderTop: '1px solid #D6B1FD' }}
                >
                  <span id="jobDetailKey" className={classes.jobDetailKey}>
                    QUANTITY TO MAKE :{' '}
                  </span>
                  <span id="jobDetailValue" className={classes.jobDetailValue}>
                    &nbsp;{commaSeparatedNumbers(jobDetails?.qty_containers_to_fill || 0)}
                  </span>
                </div>
                <div
                  id="jobDetailsRow"
                  className={classes.jobDetailsRow}
                  style={{ borderTop: '1px solid #D6B1FD', borderBottom: '1px solid #D6B1FD' }}
                >
                  <span id="jobDetailKey" className={classes.jobDetailKey}>
                    PRIORITY :{' '}
                  </span>
                  <span id="jobDetailValue" className={classes.jobDetailValue}>
                    &nbsp;{jobDetails?.priority}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(JobTagScreen);
